
<froala
    :id="id"
    ref="editor"
    :value="value"
    :tag="'textarea'"
    :config="froalaConfig"
  ></froala>
